import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomePage from '../pages/HomePage'
// import ProductPage from '../pages/ProductPage'
// import CategoryPage from '../pages/CategoryPage'
import SearchPage from '../pages/SearchPage'
import StaticPage from '../pages/StaticPage'
import CartPage from '../pages/CartPage'
import CheckoutPage from '../pages/CheckoutPage'
import OrderReceivedPage from '../pages/OrderReceivedPage'
import OrderFailurePage from '../pages/OrderFailurePage'
import ErrorPage from '../pages/ErrorPage'
import BlogPage from '../pages/BlogPage'
import ThankyouPage from '../pages/ThankyouPage'
import NotFoundPage from '../pages/NotFoundPage'
import RepairServicePage from '../pages/RepairServicePage'
import WaitForRedirect from '../components/static/WaitForRedirect.vue'
import redirectsJSON from '../data/redirectsNew.json'
import forceRedirects from '../data/forceRedirects.json'
import { abortController } from '../abortController'

const { redirects } = redirectsJSON

const Home = () =>
  import(
    /* webpackPreload: true,  webpackChunkName: "home"*/ '../pages/HomePage'
  )
const Product = () =>
  import(
    /* webpackPreload: true,  webpackChunkName: "product"*/ '../pages/ProductPage'
  )
const Category = () =>
  import(
    /* webpackPreload: true,  webpackChunkName: "category"*/ '../pages/CategoryPage'
  )

Vue.use(VueRouter)

const routerFactory = (store, VUE) => {
  // const routesRedirects = redirects.map(({ from, to }) => ({
  //   path: from,
  //   redirect: to,
  // }))
  const routes = [
    {
      path: '/:lang?/about-us',
      name: 'AboutPage',
      component: StaticPage,
      props: { slug: 'about' },
    },
    {
      path: '/:lang?/sitemap',
      name: 'SitemapPage',
      component: StaticPage,
      props: { slug: 'sitemap' },
    },
    {
      path: '/:lang?/repair',
      redirect: '/:lang?/service/',
    },
    {
      path: '/:lang?/trade-in',
      name: 'TradeInPage',
      component: StaticPage,
      props: { slug: 'tradein' },
    },
    {
      path: '/:lang?/delivery',
      name: 'DeliveryPage',
      component: StaticPage,
      props: { slug: 'delivery' },
    },
    {
      path: '/:lang?/warranty',
      name: 'WarrantyPage',
      component: StaticPage,
      props: { slug: 'warranty' },
    },
    // {
    //   path: '/:lang?/franchise',
    //   name: 'FranchisePage',
    //   component: StaticPage,
    //   props: { slug: 'franchise' },
    // },
    {
      path: '/:lang?/contacts',
      name: 'ContactsPage',
      component: StaticPage,
      props: { slug: 'contacts' },
    },
    {
      path: '/:lang?/privacy-policy',
      name: 'PrivacyPage',
      component: StaticPage,
      props: { slug: 'privacypolicy' },
    },
    {
      path: '/:lang?/terms-and-conditions',
      name: 'TermsPage',
      component: StaticPage,
      props: { slug: 'terms' },
    },
    {
      path: '/:lang?/cart',
      name: 'CartPage',
      component: CartPage,
    },
    {
      path: '/:lang?/checkout',
      name: 'CheckoutPage',
      component: CheckoutPage,
    },
    {
      path: '/:lang?/checkout/order-received/:id',
      name: 'OrderReceivedPage',
      component: OrderReceivedPage,
    },
    {
      path: '/:lang?/checkout/order-failure/:id',
      name: 'OrderFailurePage',
      component: OrderFailurePage,
    },
    {
      path: '/:lang?/thankyou',
      name: 'ThankyouPage',
      component: ThankyouPage,
    },
    {
      path: '/:lang?/error',
      name: 'ErrorPagePage',
      component: ErrorPage,
    },
    {
      path: '/:lang?/search',
      name: 'SearchPage',
      component: SearchPage,
    },
    {
      path: '/:lang?/product-category',
      redirect: '/:lang?/product-category/gadgets',
    },
    {
      path: '/:lang?/product-category/used',
      redirect: '/:lang?/product-category/used/iphone',
    },
    {
      path: '/:lang?/product-category/*',
      name: 'CategoryPage',
      component: Category,
    },
    {
      path: '/:lang?/service/:category?/:subcategory?/:service?',
      name: 'RepairServicePage',
      component: RepairServicePage,
    },
    {
      path: '/:lang?/product/*',
      name: 'ProductPage',
      component: Product,
    },
    {
      path: '/:lang?/blog/:slug?',
      name: 'BlogPage',
      component: BlogPage,
      // route level code-splitting
      // this generates a separate chunk (blog.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      // component: () =>
      // import(/* webpackChunkName: "blog" */ '../pages/BlogPage'),
    },
    {
      path: '/:lang(ua||ru)?',
      name: 'HomePage',
      component: Home,
    },
    {
      path: '/:lang?/redirecting',
      name: 'WaitForRedirect',
      component: WaitForRedirect,
    },
    {
      path: '/404',
      name: 'NotFoundPage',
      component: NotFoundPage,
      beforeEnter: (to, from, next) => {
        const redirect = redirects.find(redirect => redirect.from === from.path)

        if (redirect) {
          router.push(redirect.to)
          return false
        }

        if (/gadgets/gm.test(from.params.pathMatch)) {
          const pathChain = from.params.pathMatch.split('/')
          const fixedPathChain = []
          pathChain.forEach(item => {
            if (item !== 'gadgets') {
              fixedPathChain.push(item.replace(/1+$/g, ''))
            }
          })

          router.push({
            name: from.name,
            params: {
              lang: from.params.lang,
              pathMatch: fixedPathChain.join('/'),
            },
          })
          return false
        }

        try {
          switch (from.name) {
            case 'ProductPage':
              router.push({
                name: 'CategoryPage',
                params: {
                  lang: from.params.lang,
                  pathMatch: from.params.pathMatch.split('/')[0],
                },
              })
              return false
            default:
              next()
              break
          }
        } catch (error) {
          console.log('*[VUE Router error]', error)
          next()
        }
      },
    },
    {
      path: '*',
      redirect: '/404',
    },
  ]

  const router = new VueRouter({
    mode: 'history',
    base: VUE.h.env('BASE_URL', 'http://localhost:8080'),
    routes,
  })

  router.beforeEach((to, from, next) => {
    const oldUrlID = forceRedirects.find(
      forceRedirect => forceRedirect.from === to.path
    )

    if (oldUrlID) {
      console.log('oldUrlID', oldUrlID)
      return router.push(oldUrlID.to)
    }
    if (to.name === 'CategoryPage' && from.name === 'CategoryPage') {
      abortController.abortPendingRequest()
    }
    return next()
  })

  // router.beforeEach((to, from, next) => {
  //   const { redirectedFrom, name, fullPath } = to

  //   if (name === 'NotFoundPage' && !redirectedFrom) {
  //     return next()
  //   }

  //   const { redirects } = store.getters
  //   const allowedUrls = ['/', redirects[0].to]

  //   if (!allowedUrls.includes(fullPath)) {
  //     const decodedRedirectedFrom = decodeURI(
  //       redirectedFrom || fullPath
  //     ).replace(/\/$/gm, '')

  //     console.log('decodedRedirectedFrom', decodedRedirectedFrom)

  //     if (/\/\//gm.test(redirectedFrom || fullPath)) {
  //       return router.push(redirects[0].to)
  //     }

  //     for (let i = 0; i < redirects.length; i++) {
  //       const redirect = redirects[i]
  //       if (
  //         redirect.from.includes(decodedRedirectedFrom) ||
  //         redirect.from.includes(fullPath)
  //       ) {
  //         return router.push(redirect.to)
  //       }
  //     }
  //   }

  //   return next()
  // })

  router.afterEach((to, from) => {
    if (store.getters.notices.length) {
      store.dispatch('clearNotices')
    }
    if (store.getters.notice) {
      store.dispatch('clearNotice')
    }
    if (store.getters.addedCartNotice) {
      store.dispatch('unsetAddedCartNotice')
    }
    if (
      to.path.match(/^\/product-category/) &&
      from.path.match(/^\/product-category/)
    ) {
      // console.log('*[resetFilters]')
      store.dispatch('resetFilters')
    }
    store.dispatch('resetScroll')
  })

  return router
}

export default routerFactory
